import { render, staticRenderFns } from "./LeftBar.vue?vue&type=template&id=506c5da2&"
import script from "./LeftBar.vue?vue&type=script&lang=js&"
export * from "./LeftBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506c5da2')) {
      api.createRecord('506c5da2', component.options)
    } else {
      api.reload('506c5da2', component.options)
    }
    module.hot.accept("./LeftBar.vue?vue&type=template&id=506c5da2&", function () {
      api.rerender('506c5da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "backoffice/themes/base/src/components/LeftBar/LeftBar.vue"
export default component.exports